import { profileContentRenderedEvent } from "../events/profileContentRenderedEvent";
import { initFancybox } from "../../../../../../themes/growtype/resources/scripts/plugins/fancybox/initFancybox";

export function chatProfile() {

    document.addEventListener('growtypeChatProfileContentRendered', function (event) {
        let slider = $(event.detail.content).find('.growtype-theme-slider');
        let sliderSettings = slider.attr('data-gslick');

        if (sliderSettings && $.fn.slick && !slider.hasClass('slick-initialized')) {
            try {
                sliderSettings = JSON.parse(sliderSettings);
                slider.slick(sliderSettings);
            } catch (e) {
                console.warn('Failed to parse slider settings');
            }
        }

        $(event.detail.content).find('.growtype-theme-fancybox').each(function () {
            initFancybox($(this));
        });
    });

    if (window._growtypeChatShellPending) {
        document.addEventListener('growtype_chat_shell_ready', function onShellReady() {
            document.removeEventListener('growtype_chat_shell_ready', onShellReady);
            _chatProfileInit();
        });
        return;
    }

    _chatProfileInit();
}

function _chatProfileInit() {
    const chatProfileRender = $('.g-chatform-profile-render');

    if (chatProfileRender.length === 0) {
        const serverRenderedProfile = $('.g-chatform-profile > .g-chatprofile').first();
        if (serverRenderedProfile.length) {
            document.dispatchEvent(profileContentRenderedEvent({
                content: serverRenderedProfile.get(0),
            }));
        }
        return;
    }

    const rawArgs = chatProfileRender.attr('data-args');
    let args = {};

    try {
        args = rawArgs ? JSON.parse(rawArgs) : {};
    } catch (error) {
        args = {};
    }

    if (!args.request_url) {
        args.request_url = window.location.href;
    }

    const requestOptions = {
        url: growtype_chat_ajax.url,
        type: 'POST',
        data: {
            action: 'growtype_chat_profile_render',
            args: JSON.stringify(args),
            nonce: growtype_chat_ajax.nonce,
        },
        success: function (response) {
            if (response.success && response.data?.render) {
                const chatContent = response.data.render;

                // Replace old content with new
                const newContentElement = $(chatContent);
                chatProfileRender.replaceWith(newContentElement);

                // Dispatch event
                document.dispatchEvent(profileContentRenderedEvent({
                    content: newContentElement.get(0),
                }));
            } else {
                console.error('chatProfile: Invalid response format', response);
            }
        },
        error: function (xhr, status, error) {
            console.error('chatProfile: AJAX error', error);
        }
    };

    const prefetched = window._growtypeChatShellInitialResponses?.profile;
    if (prefetched) {
        delete window._growtypeChatShellInitialResponses.profile;
        requestOptions.success(prefetched);
        return;
    }

    jQuery.ajax(requestOptions);
}
